<template>
  <v-form ref="form">
    <v-row dense>
        <v-col v-for="(field, i) in formCreate.fields" :key="i" :cols="field.cols" :offset="field.offset">

          <v-text-field v-if="field.field == 'text' && !field.hidden"
            v-model="model[field.nameid]"
            :label="field.name"
            :type="field.type"
            :rules="(field.rules) ? fieldRequired : []"
            outlined
            dense/>

            <DatePicker v-else-if="field.field == 'textDatePicker' && !field.hidden" :itemAction="field" :on-success="actionFieldData"/>

            <SearchEmployee v-else-if="field.field == 'searchDataServer'"
              :itemAction="field"
              :on-success="actionFieldData"
              :clear="deleteds"/>

            <v-textarea v-else-if="field.field == 'textArea'"
                v-model="model[field.nameid]"
                :label="field.name"
                :name="field.dimens"
                :placeholder="field.name"
                :rules="(field.rules) ? fieldRequired : []"
                outlined
                dense>
            </v-textarea>

            <v-select v-else-if="field.field == 'select'"
                v-model="model[field.nameid]"
                :items="field.items"
                :label="field.name"
                outlined
                dense
                :rules="(field.rules) ? fieldRequired : []">
            </v-select>

            <SelectedMain v-else-if="field.field == 'selectDataServer'" :itemAction="field" :on-success="actionFieldData" />

            <div v-else-if="field.field == 'radioButton'">
              <label class="text--black font-weight-bold font-weight-black">{{field.name}}</label>
              <v-radio-group v-model="model[field.nameid]" row @change="RadioChange(field)"
                  :rules="(field.rules !== null) ? fieldRequired : []">
                <v-radio v-for="value in field.items" :key="value" :label="value" :value="value"></v-radio>
              </v-radio-group>
            </div>
            <v-row v-else-if="field.field == 'checkbox'">
                <v-checkbox
                v-for="(value,i) in field.items"
                :key="i"
                v-model="model.selected"
                :label="value"
                :value="value">
                </v-checkbox>
            </v-row>

            <v-switch
              v-else-if="field.field == 'switch'"
              v-model="model[field.nameid]"
              :label="field.name"
              :rules="(field.rules !== null) ? fieldRequired : false">
            </v-switch>

            <DropMenuTreeView v-else-if="field.field == 'dropMenuTreeviewDataServer'" :itemAction="field" :on-success="actionFieldData" />
        </v-col>
      <v-col cols="12">
        <v-layout justify-end>
            <v-btn v-if="onCancel" color="error darken-1" depressed outlined @click="onCancel" class="mr-3"> Cancelar </v-btn>
            <v-btn color="success darken-1" depressed outlined @click="sendForm()" class="mr-3"> {{titleButton}} </v-btn>
        </v-layout>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import selectedMain from '@/components/fields/selectedMain'
import searchEmployee from '@/components/fields/searchEmployee'
import DatePicker from '@/components/fields/DatePicker'
import DropMenuTreeView from '@/components/fields/DropMenuTreeView'
export default {
  props: ['titleButton', 'formCreate', 'onSuccess', 'onCancel', 'model'],
  data: () => ({
    fieldRequired: [
      value => !!value || 'Campo Requerido.'
    ],
    deleteds: 0
  }),
  mounted () {},
  methods: {
    ...mapActions([]),
    actionFieldData (obj) {
      this.model[obj.id] = (obj.data) ? obj.data : null
      if (obj.objectnameid) {
        this.model[obj.objectnameid] = (obj.objectdata) ? obj.objectdata : null
      }
    },
    RadioChange (field) {
      if (field.action) {
        this[field.action](field)
      }
    },
    ShowAndHeddenInput (field) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.formCreate.status_start.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              form.hidden = !form.hidden
            }
          })
        })
      }
    },
    sendForm () {
      if (this.$refs.form.validate()) {
        const item = this.validateComponents()
        if (this.validateComponents()) {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Advertencia!',
            text: ' Campo ' + item.name + ' no debe ser vacio!!'
          })
        } else {
          this.onSuccess(this.model)
          this.clearComponents()
        }
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Advertencia!',
          text: 'Algunos campos son requeridos !!'
        })
      }
    },
    validateComponents () {
      let itemSelected = null
      this.formCreate.fields.map(item => {
        if (item.rules) {
          if (!this.model[item.nameid]) {
            itemSelected = item
          } else if (this.model[item.nameid] === null) {
            itemSelected = item
          }
        }
      })
      return itemSelected
    },
    clearComponents () {
      this.deleteds = this.deleteds + 1
    }

  },
  computed: {
    ...mapGetters([])
  },
  components: {
    SelectedMain: selectedMain,
    SearchEmployee: searchEmployee,
    DatePicker,
    DropMenuTreeView
  }

}
</script>

<style>
</style>
